/* BoxHero Supply theme scripts */
(function () {
  'use strict';

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartCount() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(form) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
        return data;
      });
    });
  }

  /* Quick add buttons on product cards */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-add-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    addToCart(form)
      .then(function () {
        refreshCartCount();
        if (btn) {
          var label = btn.getAttribute('aria-label') || '';
          btn.setAttribute('aria-label', 'Added. ' + label.replace(/^Added\. /, ''));
          btn.classList.add('is-added');
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* Product page */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var skuEl = section.querySelector('[data-sku]');
    var addBtn = section.querySelector('[data-add]');
    var addLabel = section.querySelector('[data-add-label]');
    var addedEl = section.querySelector('[data-added]');
    var addedText = section.querySelector('[data-added-text]');
    var errorEl = section.querySelector('[data-error]');
    var qtyInput = section.querySelector('[data-qty]');

    /* Gallery thumbs */
    var slides = section.querySelectorAll('[data-slide]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    function showSlide(i) {
      slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === String(i)); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-thumb') === String(i);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.getAttribute('data-thumb')); });
    });

    /* Variant options */
    function selectedOptions() {
      var values = [];
      section.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        values[Number(fs.getAttribute('data-option-index'))] = checked ? checked.value : null;
      });
      return values;
    }

    function updateVariant() {
      var opts = selectedOptions();
      if (!opts.length) return;
      var variant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === o; });
      });
      opts.forEach(function (val, i) {
        var label = section.querySelector('[data-option-value="' + i + '"]');
        if (label) label.textContent = val;
      });
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, data.currency, data.locale);
      if (compareEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price, data.currency, data.locale);
      }
      if (skuEl) skuEl.textContent = variant.sku ? 'SKU ' + variant.sku : '';
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      if (variant.featured_media) {
        var slide = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) showSlide(slide.getAttribute('data-slide'));
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (addedEl) addedEl.hidden = true;
    }
    section.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    /* Quantity */
    section.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-qty-step')));
        qtyInput.value = next;
        if (addedEl) addedEl.hidden = true;
      });
    });

    /* Add to cart */
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.disabled = true;
        if (errorEl) errorEl.hidden = true;
        addToCart(form)
          .then(function () {
            var q = qtyInput ? qtyInput.value : 1;
            if (addedText) addedText.textContent = 'Added ' + q + ' to your cart.';
            if (addedEl) addedEl.hidden = false;
            refreshCartCount();
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () { addBtn.disabled = false; });
      });
    }
  });

  /* Collection filters and sort */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      window.location.search = params.toString();
    });
  });
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Close mobile menu on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.mobile-nav[open]').forEach(function (d) { d.removeAttribute('open'); });
  });
})();
